export default {
    set(cname, cvalue, exdays) {
        let d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + (exdays === 'expire' ? 'Thu, 01 Jan 1970 00:00:01 GMT;' : d.toUTCString());
        document.cookie = cname + "=" + cvalue + ";" + expires + ";domain=.mandy.com;path=/";
    },

    get(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },

    delete(cname) {
        this.set(cname, '', 'expire');
    },

    check(cname) {
        return this.get(cname) !== '';
    }
};